import {NameInOther, Other} from '@wix/auto_sdk_ecom_current-cart';

export class ViolationOtherTargetModel {
  public name?: ViolationOtherTargetName;

  constructor(params: ViolationOtherTargetModel) {
    this.name = params.name;
  }

  public static fromSDK(otherTarget: Other): ViolationOtherTargetModel {
    return new ViolationOtherTargetModel({
      name: otherTarget?.name && sdkToViolationOtherTargetName(otherTarget.name as NameInOther),
    });
  }
}

export enum ViolationOtherTargetName {
  default = 'OTHER_DEFAULT',
}

const sdkToViolationOtherTargetName = (name: NameInOther): ViolationOtherTargetName => {
  const map: Record<NameInOther, ViolationOtherTargetName> = {
    [NameInOther.OTHER_DEFAULT]: ViolationOtherTargetName.default,
  };

  return map[name];
};
